module.exports = __webpack_public_path__ + "static/media/wine.d3730a14.svg";